module.exports = __webpack_public_path__ + "static/media/infoIcon.f49dac96.svg";